export enum AirQualityDemoGroupType {
    FIRSTGROUP = 'FIRSTGROUP',
    SECONDGROUP = 'SECONDGROUP',
    THIRDGROUP = 'THIRDGROUP',
}
